/*
*
*/
export const getTotalOpportunityEconomies = async ({state, effects}, data) => {
  const {opportunityEconomies} = await effects.gql.queries.opportunityEconomies(data)

  state.opportunityEconomy.totalRecords = opportunityEconomies ? opportunityEconomies.length : 0
}

/*
*
*/
export const getOpportunityEconomies = async ({state, effects}, data) => {
  console.log('action getOpportunityEconomies...')
  try {
    let options = {}
    if (!data) {
      options = {
        first: state.opportunityEconomy.opportunityEconomyPerPage,
        skip: (state.opportunityEconomy.activePage - 1) * state.opportunityEconomy.opportunityEconomyPerPage
      }
    } else {
      if (data && data.all) options = {}
      else {
        options = data;
        if (!data.first) options.first = state.opportunityEconomy.opportunityEconomyPerPage;
        if (!data.skip) options.skip = (state.opportunityEconomy.activePage - 1) * state.opportunityEconomy.opportunityEconomyPerPage;
      }
    }
    //
    const {opportunityEconomies} = await effects.gql.queries.opportunityEconomies(options)
    if (data && data.getValues) return opportunityEconomies
    else state.opportunityEconomy.opportunityEconomies = opportunityEconomies
  } catch (e) {
    console.log(e, 'getOpportunityEconomies errors');
  }
}

/*
*
*/
export const saveOpportunityEconomy = async ({effects, actions}, data) => {
  try {
    return await effects.gql.mutations.saveOpportunityEconomy(data)
  } catch (e) {
    console.log(e, 'saveOpportunityEconomy errors')
    actions.alert.showError({
      message: e.response && e.response.errors && e.response.errors.length ? e.response.errors[0]['message'] : 'Error',
      title: 'Saving OpportunityEconomy'
    });
  }
}

/*
*
*/
export const onChangePage = async ({state}, page) => {
  state.opportunityEconomy.activePage = page
}

/*
*
*/
export const onOpportunityEconomyAdded = ({state}, data) => {
  state.opportunityEconomy.push(data)
}
